type Props = {
  groupSize: number | null | undefined;
  playersLength: number;
};

export function getOtherPlayerCapacity({
  groupSize,
  playersLength,
}: Props): number {
  const effectiveGroupSize = groupSize || 1;
  return effectiveGroupSize - playersLength;
}
